export const MentionEntityType = {
    USER: 'user',
    CONTACT: 'contact',
};
const MENTION_PATTERN = /@\[([^\]\n]+)\]\((user|contact):([a-zA-Z0-9-]+)\)/g;
const USER_MENTION_PATTERN = /@\[([^\]\n]+)\]\(user:([a-zA-Z0-9-]+)\)/g;
export function createMentionToken(entityType, entityId, label) {
    const safeLabel = label.replace(/[\[\]\n\r]/g, '').trim();
    return `@[${safeLabel}](${entityType}:${entityId})`;
}
export function createUserMentionToken(userId, label) {
    return createMentionToken('user', userId, label);
}
export function parseMentionTokens(value) {
    return Array.from(value.matchAll(MENTION_PATTERN), (match) => ({
        raw: match[0],
        label: match[1],
        entityType: match[2],
        entityId: match[3],
        start: match.index,
        end: match.index + match[0].length,
    }));
}
export function parseUserMentionTokens(value) {
    return Array.from(value.matchAll(USER_MENTION_PATTERN), (match) => ({
        raw: match[0],
        label: match[1],
        userId: match[2],
        start: match.index,
        end: match.index + match[0].length,
    }));
}
export function userMentionTokensToPlainText(value) {
    return value.replace(MENTION_PATTERN, (_raw, label) => label);
}
export function mentionTokensToPlainText(value) {
    return value.replace(MENTION_PATTERN, (_raw, label) => label);
}
